class BaseCallback {
  platform = '';

  constructor(platform) {
    this.platform = platform;
  }

  /**
   * 返回成功的数据
   * @param msg
   * @param data
   * @returns {{msg, code: number, data, platform: string}}
   */
  success({ msg, data }) {
    return {
      code: 0,
      platform: this.platform,
      msg,
      data,
    };
  }

  /**
   * 返回失败的数据
   * @param msg
   * @param data
   * @returns {{msg, code: number, data, platform: string}}
   */
  fail({ msg, data }) {
    return {
      code: -1,
      platform: this.platform,
      msg,
      data,
    };
  }
}

export { BaseCallback };
